import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import LoadingSpinner from './LoadingSpinner'

interface ProtectedRouteProps {
  children: ReactNode
  /** Panel de administrador: solo role === 'admin'. Si un "operator" entra
   * por URL directa (el nav ya oculta el enlace), se le manda a "/" en vez
   * de a /login — sí tiene sesión válida, solo no el permiso necesario. */
  adminOnly?: boolean
}

/**
 * H4 del roadmap (Fase B #5): protege todas las rutas del dashboard,
 * redirigiendo a /login si no hay sesión válida. Guarda la ruta que se
 * intentaba visitar (location.state.from) para volver ahí tras el login.
 */
const ProtectedRoute = ({ children, adminOnly = false }: ProtectedRouteProps) => {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <LoadingSpinner />
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
